/* Klarna instalment badge (Claude 2026-08-24, Mike's directive).
 *
 * Renders "or N interest-free payments of £X with Klarna." under Add-to-Basket
 * buttons, tracking the LIVE displayed total (BYC configurator totals change
 * with qty/medallion; Crown/SPINsert with finish/offer). Self-contained — no
 * Klarna script, no account config needed; amounts derive from the price the
 * customer is already looking at, so currency is always the presented one.
 *
 * ENABLED_CCYS: Mike enabled Klarna for all markets in Shopify Payments on
 * 2026-08-24, so all site currencies are on. (Before that a 4,000-order audit
 * showed Klarna GBP-only.)
 *
 * Surfaces:
 *   [data-byclg-atc]              BYC configurator (price: [data-byclg-total])
 *   .cl-buybtn[data-atc]          Crown / SPINsert buy (price: selected .cl-offer .cl-now)
 *   [data-product-form] .atc      V3 PDP (price: [data-running-total])
 *   [data-simple-atc]             Simple PDP (price: [data-simple-price])
 */
(function () {
  'use strict';
  var ENABLED_CCYS = { GBP: true, USD: true, CAD: true, AUD: true, EUR: true };
  var PARTS_BY_CCY = { GBP: 3, EUR: 3, USD: 4, CAD: 4, AUD: 4 }; // Klarna Pay in 3 (UK/EU) / Pay in 4
  var ccy = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  if (!ENABLED_CCYS[ccy]) return;
  var parts = PARTS_BY_CCY[ccy] || 4;

  function parseMoney(text) {
    if (!text) return null;
    var t = String(text).replace(/[^0-9.,]/g, '');
    if (!t) return null;
    // en-* formats only (£1,234.56): commas are thousands separators.
    t = t.replace(/,/g, '');
    var v = parseFloat(t);
    return isFinite(v) && v > 0 ? v : null;
  }
  // Match the site's own money style (plain $ for USD/CAD/AUD, not "US$").
  var LOCALE_BY_CCY = { GBP: 'en-GB', USD: 'en-US', CAD: 'en-CA', AUD: 'en-AU', EUR: 'en-IE' };
  function fmt(v) {
    try { return new Intl.NumberFormat(LOCALE_BY_CCY[ccy] || 'en-GB', { style: 'currency', currency: ccy }).format(v); }
    catch (_) { return ccy + ' ' + v.toFixed(2); }
  }

  function ensureBadge(btn) {
    var next = btn.nextElementSibling;
    if (next && next.classList && next.classList.contains('chuug-klarna')) return next;
    var el = document.createElement('div');
    el.className = 'chuug-klarna';
    el.setAttribute('aria-live', 'polite');
    el.innerHTML = '<span class="chuug-klarna__logo" aria-label="Klarna">Klarna.</span><span class="chuug-klarna__txt"></span><span class="chuug-klarna__legal">18+, T&amp;Cs apply. Credit subject to status.</span>';
    btn.insertAdjacentElement('afterend', el);
    return el;
  }
  function setBadge(btn, totalMajor) {
    var el = ensureBadge(btn);
    var txt = el.querySelector('.chuug-klarna__txt');
    if (totalMajor == null) { el.style.display = 'none'; return; }
    var each = Math.round((totalMajor / parts) * 100) / 100;
    el.style.display = '';
    txt.textContent = 'or ' + parts + ' interest-free payments of ' + fmt(each);
  }

  // Each target resolves its own current price text.
  function bycPrice(btn) {
    var t = btn.querySelector('[data-byclg-total]');
    return t ? parseMoney(t.textContent) : null;
  }
  function crownPrice(btn) {
    var sec = btn.closest('[data-crown-sec]');
    if (!sec) return null;
    var sel = sec.querySelector('.cl-offer.cl-sel .cl-now') || sec.querySelector('.cl-offer .cl-now');
    return sel ? parseMoney(sel.textContent) : null;
  }
  function pdpPrice(btn) {
    var f = btn.closest('form');
    var t = f && f.querySelector('[data-running-total]');
    return t ? parseMoney(t.textContent) : null;
  }
  function simplePrice(btn) {
    var sec = btn.closest('#pdp-simple') || document;
    var t = sec.querySelector('[data-simple-price]');
    return t ? parseMoney(t.textContent) : null;
  }

  var TARGETS = [
    { sel: '[data-byclg-atc]', price: bycPrice },
    { sel: '.cl-buybtn[data-atc]', price: crownPrice },
    { sel: '[data-product-form] button.atc', price: pdpPrice },
    { sel: '[data-simple-atc]', price: simplePrice }
  ];

  var found = [];
  function scan() {
    TARGETS.forEach(function (t) {
      document.querySelectorAll(t.sel).forEach(function (btn) {
        if (btn.__chuugKlarna) return;
        btn.__chuugKlarna = true;
        found.push({ btn: btn, price: t.price });
      });
    });
  }
  function renderAll() {
    found.forEach(function (f) {
      try { setBadge(f.btn, f.price(f.btn)); } catch (_) {}
    });
  }

  function init() {
    scan();
    if (!found.length) return; // nothing on this page — zero cost
    renderAll();
    // Totals are re-rendered by section JS on every interaction: observe the
    // document body once, debounced, and re-derive. Cheap (text lookups only).
    var pending = null;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; scan(); renderAll(); }, 200);
    });
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
